import type { CharacterEncounter } from '../types/character.types';
import type { CharacterLanguage } from './character-labels';

export function encounterOffersDecision(encounter: CharacterEncounter): boolean {
  return encounter.status === 'active' && encounter.options.length > 0 &&
    encounter.stageId !== 'battle' && encounter.stageId !== 'travel';
}

export function encounterStageTitle(stage: string, language: CharacterLanguage): string {
  const titles: Record<string, [string, string]> = {
    battle: ['Бой', 'Battle'], aftermath: ['После боя', 'After the battle'],
    protection: ['Конфликт', 'Conflict'], captivity: ['Плен', 'Captivity'],
  };
  return titles[stage]?.[language === 'ru' ? 0 : 1] ?? (language === 'ru' ? 'Встреча' : 'Encounter');
}

export function encounterWaitingText(stage: string, language: CharacterLanguage): string {
  const messages: Record<string, [string, string]> = {
    battle: ['Бой продолжается.', 'The battle is ongoing.'],
    travel: ['Герой в пути.', 'The hero is on the road.'],
    captivity: ['Герой остаётся в плену.', 'The hero remains captive.'],
  };
  return messages[stage]?.[language === 'ru' ? 0 : 1] ??
    (language === 'ru' ? 'Ждём развития событий.' : 'Waiting for the next development.');
}

export function encounterShowsRoster(stage: string): boolean {
  return ['battle', 'aftermath', 'protection', 'captivity'].includes(stage);
}

export function encounterHeroStatusText(summary: unknown, language: CharacterLanguage): string | null {
  if (!summary || typeof summary !== 'object' || Array.isArray(summary)) return null;
  const status = (summary as Record<string, unknown>).heroStatus;
  if (typeof status !== 'string') return null;
  const messages: Record<string, [string, string]> = {
    fled: ['Герой отступил.', 'The hero withdrew.'],
    surrendered: ['Герой сложил оружие.', 'The hero surrendered.'],
    dead: ['Герой погиб.', 'The hero died.'],
    captive: ['Герой находится в плену.', 'The hero is captive.'],
  };
  return messages[status]?.[language === 'ru' ? 0 : 1] ?? null;
}
